import styled, { css } from 'styled-components';

export const SenderName = styled.div`
  ${({ theme }) => css`
    font-weight: 600;
    font-size: 12px;
    color: ${theme.colour.primary};
    line-height: 14px;
  `}
`;
